import React from 'react';
import classNames from 'classnames';
import Tooltip, { Size as TooltipSize } from 'components/general/tooltip/tooltip';
import Icon, { Size as IconSize } from 'components/general/icon/icon';

const styles = require('./form_input.module.scss');

interface TooltipConfig {
  content: string | any[];
  size: TooltipSize;
  floating?: boolean;
  iconColor?: string;
}

type TooltipProp = string | TooltipConfig;

interface Props {
  className?: string;
  children: any;
  description?: string;
  error?: string;
  label?: any;
  required?: boolean;
  name?: string;
  sublabel?: string;
  tooltip?: TooltipProp;
  tooltipOnSublabel?: boolean;
  labelClass?: string;
}

const FormInput = (props: Props) => {
  const contentProps = {};
  let tooltipConfig: TooltipConfig | null = null;

  if (props.tooltip) {
    tooltipConfig =
      typeof props.tooltip === 'string'
        ? { content: props.tooltip, size: TooltipSize.Medium }
        : props.tooltip;

    const key = typeof tooltipConfig.content === 'string' ? 'text' : 'htmlContent';
    contentProps[key] = tooltipConfig.content;
  }

  const renderTooltip = () => {
    if (!tooltipConfig) return null;

    return (
      <Tooltip {...contentProps} size={tooltipConfig.size} textBelow={true}>
        <div className={styles.iconWrapper}>
          <Icon
            name={'helpCircle'}
            color={tooltipConfig.iconColor || 'silverSandXxDark'}
            size={IconSize.Medium}
          />
        </div>
      </Tooltip>
    );
  };

  return (
    <div id={props.name} className={classNames('formInput', props.className)}>
      {props.label && (
        <div className={props.labelClass || styles.label}>
          {props.label}
          {props.required && <abbr title='required'> *</abbr>}
          {props.sublabel && (
            <div className={styles.sublabel}>
              {props.sublabel}
              {props.tooltip && props.tooltipOnSublabel && renderTooltip()}
            </div>
          )}
          {props.tooltip && !props.tooltipOnSublabel && renderTooltip()}
          <div className={styles.description}>{props.description}</div>
        </div>
      )}
      <div>
        {props.children}
        {props.error && (
          <div className={classNames('errorMessage', styles.errorMessage)}>{props.error}</div>
        )}
      </div>
    </div>
  );
};

export default FormInput;
